import { useNavigate } from "react-router-dom";
import LineFilter from "../../Components/GrantsSeacher/LineFilter";
import CardHeader from "../../antd/components/CardHeader";
import { FaHeart } from 'react-icons/fa';
import './styles.css';
import { Layout } from "antd";
interface Grant {
    id: number;
    title: string;
    description: string;
    isFavorite?: boolean;
}
const GrantsSearcher = () => {
    const navigate = useNavigate();
    const grants: Grant[] = [];
    function handleFavorites() {
        navigate("/grantsSearcher/grants", { state: { justFavorites: true } });
    }
    const buttons = [
        {
            name: "Exibir Linhas Favoritas",
            icon: <FaHeart />,
            action: handleFavorites,
            iconAfter: true,
            disabled: false // botão desabilitado
        }
    ];
    return (
        <Layout style={{
            background: 'white',
            padding: '0 30px 30px',
            marginTop: '16px',
            borderRadius: '8px'
        }}>
            <CardHeader
                pageName={"Buscador de Linhas"}
                hasPageBefore={false}
            //buttons={buttons} // adiciona o botão
            />
            <div className='card-body'>
                <LineFilter grants={grants} />
                <div className="title-with-line">
                    <div className="line-divider"></div>
                    <h3> Listagem de Linhas</h3>
                    <div className="line-divider"></div>
                </div>
            </div>
        </Layout>
    )
}
export default GrantsSearcher;